/**
 * Configuração central dos filtros de métrica do dashboard.
 *
 * Toda mudança de métrica (mapa, canais, dispositivos) consome esta lista.
 * Para adicionar uma nova métrica, basta acrescentar uma entrada aqui e
 * (se necessário) o predicado SQL correspondente em dashboard.py.
 */

export const METRIC_FILTERS = [
  { key: 'investment',  label: 'Investimento',       icon: 'currency' },
  { key: 'impressions', label: 'Impressões',         icon: 'eye' },
  { key: 'clicks',      label: 'Cliques',            icon: 'target' },
  { key: 'visits',      label: 'Visitas',            icon: 'users' },
  { key: 'whats',       label: 'Clicks Whats',       icon: 'whats' },
  { key: 'forms',       label: 'Formulários',        icon: 'page' },
  { key: 'contacts',    label: 'Contatos',           icon: 'phone' },
  { key: 'leads',       label: 'Leads',              icon: 'leads' },
  { key: 'qualified',   label: 'Leads Qualificados', icon: 'check' },
  { key: 'sales',       label: 'Vendas',             icon: 'sales' },
]

export const DEFAULT_METRIC = 'leads'

export const METRIC_LABEL = Object.fromEntries(
  METRIC_FILTERS.map((m) => [m.key, m.label.toLowerCase()])
)
